<footer class="footer bg-dark">
    <div>
        <span>Met dank aan Ann en Jan.</span>
    </div>
</footer>